import { render } from "./Answers.vue?vue&type=template&id=0a7766b3"
import script from "./Answers.vue?vue&type=script&lang=ts"
export * from "./Answers.vue?vue&type=script&lang=ts"
script.render = render

export default script